import { render } from "./user-customer-report.vue?vue&type=template&id=75655930&scoped=true"
import script from "./user-customer-report.vue?vue&type=script&lang=js"
export * from "./user-customer-report.vue?vue&type=script&lang=js"

import "./user-customer-report.vue?vue&type=style&index=0&id=75655930&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75655930"]])

export default __exports__